import React from "react";
import { Facebook, Twitter, Instagram, Home, Heart, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logoess from "../assets/Logos.png";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white py-4 px-4 mt-6 shadow-lg rounded-t-2xl">
      <div className="max-w-6xl mx-auto hidden sm:grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 items-start">
        
        
        <div className="flex flex-col">
          <div className="flex items-center gap-2 mb-1">
            <img
              src={logoess}
              alt="Logo"
              className="w-14 h-14 object-contain"
            />
            
          </div>
          <p className="text-xs text-gray-400">{t("tagline")}</p>
          <p className="text-xs text-gray-500 mt-2">
            © {new Date().getFullYear()} NewBrindha. {t("copyright")}
          </p>
        </div>

        {/* Links */}
        <div className="flex flex-col space-y-1">
          <Link to="/dashboard" className="flex items-center gap-2 text-gray-300 hover:text-white transition text-sm">
            <Home size={16} /> {t("links.home")}
          </Link>
          <Link to="/favourite" className="flex items-center gap-2 text-gray-300 hover:text-white transition text-sm">
            <Heart size={16} /> {t("links.favourites")}
          </Link>
          <Link to="/matchingProfiles" className="flex items-center gap-2 text-gray-300 hover:text-white transition text-sm">
            <Users size={16} /> {t("links.matchProfiles")}
          </Link>
        </div>

        {/* Social Links */}
        <div>
          <h3 className="text-sm font-semibold mb-1">{t("followUs")}</h3>
          <div className="flex space-x-3">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">
              <Facebook size={18} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">
              <Twitter size={18} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">
              <Instagram size={18} />
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Footer */}
       <div className="sm:hidden text-center">
          <div className="flex justify-center items-center gap-1">
            <img
              src={logoess}
              alt="Logo"
              className="w-5 h-5 object-contain"
            />
          </div>
          <p className="text-[9px] text-white">
            © {new Date().getFullYear()} NewBrindha. {t("copyright")}
          </p>
          <p className="text-[9px] text-white">{t("madeWith")}</p>
        </div>
    </footer>
  );
};

export default Footer;
